import React from "react";
import BoxIcon from "../box-icon/box-icon";
import "./message-win-points.scss";
const MessageWinPoints = ({ className = "", icon = "star", text1 = "", text2 = "" }) => {
  return (<div className={'f-message-win-points ' + className}>
    <BoxIcon type={icon} />
    <div className="f-message-win-points__container">
     
        {text1}
        <span className='--pink-text'>{text2} </span>
       
    </div>
  </div>)
}

export default MessageWinPoints;